// ====================================
// CareerTransitionMatrix.jsx
// ====================================
import React from 'react';
import Icon from '@/components/AppIcon';

const CareerTransitionMatrix = ({ currentProfile, targetRole }) => {
const matchingSkills = currentProfile?.skills?.filter(skill =>
targetRole?.requiredSkills?.some(req => 
req.toLowerCase().includes(skill.toLowerCase())
)
) || [];

const missingSkills = targetRole?.requiredSkills?.filter(skill =>
!currentProfile?.skills?.some(current =>
current.toLowerCase().includes(skill.toLowerCase())
)
) || [];

return (
<div className="bg-card border border-border rounded-lg p-6">
<h3 className="text-lg font-semibold text-text-primary mb-4">Transition Analysis</h3>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
<div>
<h4 className="text-sm font-medium text-text-secondary mb-3">Transferable Skills</h4>
<div className="space-y-2">
{matchingSkills.map(skill => (
<div key={skill} className="flex items-center space-x-2">
<Icon name="CheckCircle" size={16} className="text-success" />
<span className="text-sm text-text-primary">{skill}</span>
</div>
))}
</div>
</div>

<div>
<h4 className="text-sm font-medium text-text-secondary mb-3">Skills to Develop</h4>
<div className="space-y-2">
{missingSkills.map(skill => (
<div key={skill} className="flex items-center space-x-2">
<Icon name="Circle" size={16} className="text-warning" />
<span className="text-sm text-text-primary">{skill}</span>
</div>
))}
</div>
</div>
</div>
</div>
);
};

export default CareerTransitionMatrix;